import { render, staticRenderFns } from "./Cabinet.vue?vue&type=template&id=3abdd17f&scoped=true"
import script from "./Cabinet.vue?vue&type=script&lang=js"
export * from "./Cabinet.vue?vue&type=script&lang=js"
import style0 from "./Cabinet.vue?vue&type=style&index=0&id=3abdd17f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abdd17f",
  null
  
)

export default component.exports